var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"options":_vm.province,"placeholder":"请选择市区","filterable":"","disabled":_vm.disabled},on:{"active-item-change":_vm.choseCity,"change":_vm.handleItemChange},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }